import React from "react";
import { Container, Box, Typography, Paper, Divider } from "@mui/material";
import BreadCrumbs from "../components/Breadcrumbs";

const Rules = () => {
    return (
        <Container maxWidth="xl">
            {/* Breadcrumbs */}
            <Box sx={{ width: "100%", mt: 3 }}>
                <BreadCrumbs hrefs="" name="Правила" />
            </Box>

            <Box sx={{ width: "100%", mt: 3 }}>
                <Paper sx={{ p: 3 }}>
                    <Typography variant="h4" fontWeight={600} gutterBottom>
                        Правила сервера
                    </Typography>
                    <Typography variant="body2" color="text.secondary" gutterBottom>
                        Официальные документы, регулирующие использование сайта и игрового сервера.
                    </Typography>

                    <Divider sx={{ my: 2 }} />

                    {/* Раздел 1. Технические правила сервера */}
                    <Typography variant="h5" fontWeight={500} gutterBottom>
                        Раздел 1. Технические правила сервера
                    </Typography>
                    <Box component="ol" sx={{ pl: 3 }}>
                        <li>
                            <Typography>
                                Для точной идентификации администрацией игроков на сервере OverLive. Если ник в TG отличается от игрового на сервере — указать его в скобках: ник TG [ник игровой на сервере].
                            </Typography>
                        </li>
                        <li>
                            <Typography>
                                Запрещается использование ников, схожих с Администрацией сервера, а также не читаемых или общих ников: Admin, Administrator, Moderator и т.п.
                            </Typography>
                        </li>
                        <li>
                            <Typography>
                                Запрещается использование читов и любых программ, дающих преимущество над другими игроками.
                            </Typography>
                            <Box component="ul" sx={{ pl: 3 }}>
                                <li>Меры пресечения: Перманентный бан.</li>
                            </Box>
                        </li>
                        <li>
                            <Typography>
                                Запрещается намеренное использование багов игры (несовершенство движка, механик и т.д.).
                            </Typography>
                        </li>
                        <li>
                            <Typography>Запрещен дюп предметов.</Typography>
                        </li>
                        <li>
                            <Typography>Запрещена продажа/покупка/перепродажа предметов/вещей за реальные деньги.</Typography>
                        </li>
                        <li>
                            <Typography>Запрещена реклама сторонних проектов.</Typography>
                        </li>
                    </Box>

                    <Divider sx={{ my: 2 }} />

                    {/* Раздел 2. Игровые правила сервера */}
                    <Typography variant="h5" fontWeight={500} gutterBottom>
                        Раздел 2. Игровые правила сервера
                    </Typography>
                    <Box component="ol" sx={{ pl: 3 }}>
                        <li>
                            <Typography>
                                Запрещено. Оскорбление игроков, администрации, а также провокации на оскорбление, разжигание межнациональной розни, в общем чате. (Все свои проблемы выясняйте в личке.)
                            </Typography>
                        </li>
                        <li>
                            <Typography>
                                Запрещен флуд, флуд КАПСОМ в общий чат.
                            </Typography>
                        </li>
                        <li>
                            <Typography>
                                Запрещено писать или наносить на таблички изображения, запрещенные законодательством, оскорбления, провокации и т. д.
                            </Typography>
                        </li>
                        <li>
                            <Typography>
                                Запрещено застраивать по периметру других игроков тем самым блокируя их.
                            </Typography>
                        </li>
                    </Box>

                    <Divider sx={{ my: 2 }} />

                    {/* Раздел 3. Администрация */}
                    <Typography variant="h5" fontWeight={500} gutterBottom>
                        Раздел 3. Администрация
                    </Typography>
                    <Box component="ol" sx={{ pl: 3 }}>
                        <li>
                            <Typography>
                                Администрация сервера не несет ответственности за пропажу ваших вещей (по причине грабежа) по вашей вине (забыли закрыть дверь, запереть ящик и т.д.)
                            </Typography>
                        </li>
                        <li>
                            <Typography>
                                Администрация сервера не вмешивается в игровой процесс игроков.(за исключением тестирования на сервере нововведений)
                            </Typography>
                        </li>
                        <li>
                            <Typography>
                                Администратор имеет право пользоваться своими привилегиями в интересах сервера(ивенты, события, нововведения и т.п).
                            </Typography>
                        </li>
                        <li>
                            <Typography>
                                Если не одно из правил не подходит к ситуации Администратор в праве отреагировать на свое усмотрение.
                            </Typography>
                        </li>
                    </Box>
                </Paper>
            </Box>
        </Container>
    );
};

export default Rules;